import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

interface DiscussionLinkInputProps {
  linkUrl: string;
  onLinkChange: (url: string) => void;
  error?: string;
  disabled?: boolean;
}

export function DiscussionLinkInput({
  linkUrl,
  onLinkChange,
  error,
  disabled,
}: DiscussionLinkInputProps) {
  return (
    <div className="space-y-2">
      <Label htmlFor="link_url">Company / Website URL (optional)</Label>
      <Input
        id="link_url"
        value={linkUrl}
        onChange={(e) => onLinkChange(e.target.value)}
        placeholder="https://yourcompany.com"
        disabled={disabled}
      />
      {error && (
        <p className="text-xs text-destructive">{error}</p>
      )}
    </div>
  );
}

export function validateLinkUrl(url: string): string | null {
  if (!url.trim()) return null;
  if (!url.startsWith("http://") && !url.startsWith("https://")) {
    return "URL must start with http:// or https://";
  }
  return null;
}
